import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => (
  <main className="min-h-screen flex flex-col items-center justify-center px-6 bg-darkBg">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center"
    >
      <h1 className="text-8xl md:text-9xl font-bold gradient-text mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl text-textPrimary mb-4">Page Not Found</h2>
      <p className="text-textSecondary mb-8 max-w-md mx-auto">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="btn-primary"
      >
        Go back to Home
      </Link>
    </motion.div>
  </main>
);

export default NotFound;
